import type {FunctionComponent} from 'react';
import {useMemo} from 'react';
import {useTranslation} from '@app/hooks/use-translation';

import {LandingSection} from '@tempo/landing';
import type {Article} from '@app/components/faq';
import {LandingSeoFaq} from '@app/components/faq';

export const FAQ: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['songcatcher']});

	const articles = useMemo<Article[]>(
		() => [
			{
				title: t(
					'songcatcherlandingpagefaq_text_Qhowtofindnameofsong_standalone-web',
				),
				answer: [
					t(
						'songcatcherlandingpagefaq_text_Ahowtofindnameofsong_standalone-web',
					),
				],
			},
			{
				title: t(
					'songcatcherlandingpagefaq_text_Qhowtofindsongwithlyrics_standalone-web',
					{
						ns: 'songcatcher',
					},
				),
				answer: [
					t(
						'songcatcherlandingpagefaq_text_Ahowtofindsongwithlyrics_standalone-web',
					),
				],
			},
		],
		[t],
	);
	return (
		<LandingSection isContained>
			<LandingSeoFaq articles={articles} />
		</LandingSection>
	);
};
